import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Filter, LayoutGrid, List, Search } from 'lucide-react';
import { properties, districts } from '../data/mockData';
import { PropertyCard } from '../components/shared/PropertyCard';
export const Explore = () => {
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  return <div className="min-h-screen bg-neutral-light pt-24 pb-20" data-id="element-1591">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1592">
        {/* Header */}
        <div className="mb-8" data-id="element-1593">
          <h1 className="text-3xl font-serif font-bold text-primary-900 mb-2" data-id="element-1594">
            Explore Properties
          </h1>
          <p className="text-text-light" data-id="element-1595">
            Discover verified real estate across Abuja.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8" data-id="element-1596">
          {/* Sidebar Filters */}
          <aside className="w-full lg:w-64 shrink-0" data-id="element-1597">
            <div className="bg-white rounded-2xl shadow-soft border border-neutral-200 p-5 sticky top-24" data-id="element-1598">
              <div className="flex items-center gap-2 font-serif font-bold text-lg text-primary-900 mb-6 pb-4 border-b border-neutral-100" data-id="element-1599">
                <Filter size={20} data-id="element-1600" /> Filters
              </div>

              <div className="space-y-6" data-id="element-1601">
                {/* Verified Toggle */}
                <label className="flex items-center justify-between cursor-pointer" data-id="element-1602">
                  <span className="text-sm font-medium text-text" data-id="element-1603">
                    Verified Only
                  </span>
                  <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in" data-id="element-1604">
                    <input type="checkbox" name="toggle" id="toggle" className="toggle-checkbox absolute block w-5 h-5 rounded-full bg-white border-4 appearance-none cursor-pointer transition-transform duration-200 ease-in-out translate-x-5 border-secondary" defaultChecked data-id="element-1605" />
                    <label htmlFor="toggle" className="toggle-label block overflow-hidden h-5 rounded-full bg-secondary cursor-pointer" data-id="element-1606"></label>
                  </div>
                </label>

                {/* District */}
                <div data-id="element-1607">
                  <label className="block text-xs font-bold text-text-light uppercase tracking-wider mb-3" data-id="element-1608">
                    District
                  </label>
                  <div className="space-y-2 max-h-40 overflow-y-auto pr-2 custom-scrollbar" data-id="element-1609">
                    {districts.map(d => <label key={d.id} className="flex items-center gap-2 cursor-pointer" data-id="element-1610">
                        <input type="checkbox" className="rounded text-secondary focus:ring-secondary" data-id="element-1611" />
                        <span className="text-sm text-text" data-id="element-1612">{d.name}</span>
                      </label>)}
                  </div>
                </div>

                {/* Tier */}
                <div data-id="element-1613">
                  <label className="block text-xs font-bold text-text-light uppercase tracking-wider mb-3" data-id="element-1614">
                    Tier
                  </label>
                  <div className="space-y-2" data-id="element-1615">
                    {[1, 2, 3].map(t => <label key={t} className="flex items-center gap-2 cursor-pointer" data-id="element-1616">
                        <input type="checkbox" className="rounded text-secondary focus:ring-secondary" data-id="element-1617" />
                        <span className="text-sm text-text" data-id="element-1618">Tier {t}</span>
                      </label>)}
                  </div>
                </div>

                {/* Property Type */}
                <div data-id="element-1619">
                  <label className="block text-xs font-bold text-text-light uppercase tracking-wider mb-3" data-id="element-1620">
                    Property Type
                  </label>
                  <div className="space-y-2" data-id="element-1621">
                    {['House', 'Land', 'Apartment', 'Commercial'].map(t => <label key={t} className="flex items-center gap-2 cursor-pointer" data-id="element-1622">
                        <input type="checkbox" className="rounded text-secondary focus:ring-secondary" data-id="element-1623" />
                        <span className="text-sm text-text" data-id="element-1624">{t}</span>
                      </label>)}
                  </div>
                </div>

                <button className="w-full bg-primary-50 text-primary-900 py-2 rounded-lg text-sm font-semibold hover:bg-primary-100 transition-colors" data-id="element-1625">
                  Apply Filters
                </button>
              </div>
            </div>
          </aside>

          {/* Main Content */}
          <main className="flex-grow" data-id="element-1626">
            {/* Top Bar */}
            <div className="bg-white rounded-xl shadow-sm border border-neutral-200 p-4 mb-6 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-1627">
              <div className="text-sm text-text-light" data-id="element-1628">
                Showing{' '}
                <span className="font-bold text-primary-900" data-id="element-1629">
                  {properties.length}
                </span>{' '}
                verified properties
              </div>

              <div className="flex items-center gap-4" data-id="element-1630">
                <select className="text-sm border-none bg-transparent focus:ring-0 text-text font-medium cursor-pointer" data-id="element-1631">
                  <option data-id="element-1632">Sort by: Newest</option>
                  <option data-id="element-1633">Price: Low to High</option>
                  <option data-id="element-1634">Price: High to Low</option>
                </select>

                <div className="flex items-center gap-1 bg-neutral-100 p-1 rounded-lg" data-id="element-1635">
                  <button onClick={() => setViewMode('grid')} className={`p-1.5 rounded ${viewMode === 'grid' ? 'bg-white shadow-sm text-primary-900' : 'text-text-light'}`} data-id="element-1636">
                    <LayoutGrid size={18} data-id="element-1637" />
                  </button>
                  <button onClick={() => setViewMode('list')} className={`p-1.5 rounded ${viewMode === 'list' ? 'bg-white shadow-sm text-primary-900' : 'text-text-light'}`} data-id="element-1638">
                    <List size={18} data-id="element-1639" />
                  </button>
                </div>
              </div>
            </div>

            {/* Grid */}
            <div className={`grid gap-6 ${viewMode === 'grid' ? 'grid-cols-1 md:grid-cols-2 xl:grid-cols-3' : 'grid-cols-1'}`} data-id="element-1640">
              {properties.map((property, index) => <motion.div key={property.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} data-id="element-1641">
                  <PropertyCard property={property} data-id="element-1642" />
                </motion.div>)}
            </div>
          </main>
        </div>
      </div>
    </div>;
};